import { Component } from '@theme/component';
import { sectionRenderer, morphSection } from '@theme/section-renderer';
import { RecentlyViewed } from '@theme/recently-viewed-products';
// Same fix as wishlist-section.js: product cards here only ever arrive via
// morphSection(), and <script> tags inserted through DOM morphing never
// execute, so wishlist-button's own per-card script tag never registers the
// custom element on this page. Importing it as a module dependency
// guarantees registration before this file's own top-level code runs.
import '@theme/wishlist-button';

class MyPageRecent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#load();
  }

  async #load() {
    const { sectionId, searchUrl } = this.dataset;
    if (!sectionId || !searchUrl) return;

    const products = RecentlyViewed.getProducts();

    if (products.length === 0) {
      this.#renderEmpty();
      return;
    }

    try {
      const url = new URL(searchUrl, location.origin);
      url.searchParams.set('q', products.map((/** @type {string} */ id) => `id:${id}`).join(' OR '));
      url.searchParams.set('resources[type]', 'product');

      const html = await sectionRenderer.getSectionHTML(sectionId, false, url);

      if (!html?.trim().length) {
        this.#renderEmpty();
        return;
      }

      morphSection(sectionId, html, { mode: 'hydration', injectStylesheet: true });
    } catch (error) {
      console.error('My Page recently viewed error:', error);
    }
  }

  #renderEmpty() {
    const grid = this.querySelector('[data-recent-grid]');
    const empty = this.querySelector('[data-recent-empty]');
    if (grid instanceof HTMLElement) grid.style.display = 'none';
    if (empty instanceof HTMLElement) empty.style.display = '';
  }
}

if (!customElements.get('my-page-recent')) {
  customElements.define('my-page-recent', MyPageRecent);
}
